//FireBase
var config = {
  apiKey: "AIzaSyA4QNdVzLseQMRxh5t5NHtA6ZjTI7EUZs8",
  authDomain: "the-escape-way.firebaseapp.com",
  databaseURL: "https://the-escape-way.firebaseio.com",
  projectId: "the-escape-way",
  storageBucket: "the-escape-way.appspot.com",
  messagingSenderId: "902605340470",
  appId: "1:902605340470:web:01e1256fcc7c9e91bcfd97",
  measurementId: "G-7F0NMZMTQ8"
};
  
exports.config = config;



// WEBPACK FOOTER //
// ./src/config/firebase_config.js